module.exports = "/_next/static/files/d95191e497e454b95c13f25cdb500fdb.png";